import React, { useState } from "react";
import PropTypes from "prop-types";
import LoadingDots from "./shared/LoadingDots";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const Login = ({ setUser }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const res = await fetch("/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ email, password }),
      });

      const data = await res.json();

      if (res.ok) {
        setUser(data);
        localStorage.setItem("currentUser", JSON.stringify(data));
      } else {
        setError(data.error || "Login failed");
      }
    } catch (err) {
      setError("Server error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login h-screen w-screen flex items-center justify-center">
      <div className="login-container flex flex-col justify-center items-center">
        <h2>PharmAid HMS</h2>

        {error && <p className="error">{error}</p>}

        <form onSubmit={handleLogin} className="flex flex-col gap-4 w-80">
          
          {/* Email */}
          <div className="login-email">
            <label htmlFor="login-email">Email:</label>
            <input
              id="login-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="w-full border rounded p-2"
            />
          </div>

          {/* Password with eye icon (copied style) */}
          <div>
            <label className="block mb-1" htmlFor="login-password">
              Password
            </label>

            <div className="flex mt-[5px] login-password">
              <input
                id="login-password"
                value={password}
                type="text"
                onChange={(e) => setPassword(e.target.value)}
                required
                className={`${showPassword ? "unmasked-password" : "masked-password"} w-full border rounded p-2`}
              />

              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="eyebtn"
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>
          </div>

          {/* Login button */}
          <button
            className="primary wide flex items-center justify-center gap-2"
            type="submit"
            disabled={loading}
          >
            {loading ? (
              <LoadingDots height={15} width={40} color="#fff" />
            ) : (
              "Login"
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

Login.propTypes = {
  setUser: PropTypes.func.isRequired,
};

export default Login;
